/**
 * ResponsiveImage component for optimized image loading
 * Automatically generates srcSet and sizes for responsive images
 */
export default function ResponsiveImage({ 
  src, 
  alt, 
  className = '', 
  width, 
  height,
  sizes,
  loading = 'lazy',
  fetchpriority,
  ...props 
}) {
  // Map of responsive image configurations
  const responsiveConfigs = {
    '/earth_transparent.webp': {
      srcSet: [
        '/responsive/earth_transparent-sm.webp 228w',
        '/responsive/earth_transparent-sm@2x.webp 456w',
        '/responsive/earth_transparent-md.webp 400w',
        '/responsive/earth_transparent-md@2x.webp 800w',
        '/responsive/earth_transparent-lg.webp 580w',
        '/responsive/earth_transparent-lg@2x.webp 1160w'
      ].join(', '),
      sizes: sizes || '(max-width: 640px) 60vw, (max-width: 1024px) 400px, 580px',
      fallback: '/responsive/earth_transparent-lg.webp'
    },
    '/android-chrome-96x96.png': {
      srcSet: [
        '/responsive/android-chrome-96x96-sm.webp 40w',
        '/responsive/android-chrome-96x96-sm@2x.webp 80w'
      ].join(', '),
      sizes: sizes || '40px',
      fallback: '/responsive/android-chrome-96x96-sm.webp'
    },
    '/google-play-badge.png': {
      srcSet: [
        '/responsive/google-play-badge-sm.webp 154w',
        '/responsive/google-play-badge-sm@2x.webp 308w'
      ].join(', '),
      sizes: sizes || '154px',
      fallback: '/responsive/google-play-badge-sm.webp'
    }
  };

  const config = responsiveConfigs[src];
  
  // If no responsive config, use original image
  if (!config) {
    return (
      <img 
        src={src} 
        alt={alt} 
        className={className}
        width={width}
        height={height}
        loading={loading}
        fetchpriority={fetchpriority}
        {...props}
      />
    );
  }

  return (
    <img 
      src={config.fallback}
      srcSet={config.srcSet}
      sizes={config.sizes}
      alt={alt} 
      className={className}
      width={width}
      height={height}
      loading={loading}
      fetchpriority={fetchpriority}
      {...props}
    />
  );
}
